window.initDataLayer = function() {
  window.dataLayer = window.dataLayer || [];
}
